import Cookies from "universal-cookie";

export default function getCookie(name: string): string {
  return new Cookies().get(name);
}
